import ReactGA from 'react-ga';
import { z } from 'zod';
import { log } from '@hungryroot/o11y';

export const PUBLIC_GOOGLE_ANALYTICS_ID = z
  .string()
  .parse(process.env.PUBLIC_GOOGLE_ANALYTICS_ID);

export const PUBLIC_GOOGLE_OPTIMIZE_KEY = z
  .string()
  .parse(process.env.PUBLIC_GOOGLE_OPTIMIZE_KEY);

function getGaInstance() {
  ReactGA.initialize(PUBLIC_GOOGLE_ANALYTICS_ID, {
    testMode: process.env.NODE_ENV === 'test',
  });

  return ReactGA;
}

export function ga(...args: unknown[]) {
  getGaInstance().ga(...args);
}

export function pushDataLayer(...data: unknown[]) {
  if (typeof window !== 'undefined') {
    log('GTM - Push Data Layer', { key: 'pushDataLayer', gtmData: data });
    window.dataLayer.push(...data);
  }
}
